<template>
  <div class="content">
    <ul class="content-box">
      <li class="path-item" v-for="item in courses" :key="item.id">
        <div class="item-avatar">
          <img :src="common.filepath(item.courseSet.cover.middle)" />
        </div>
        <div class="item-title">
          <p>
            {{ item.courseSet.title }}
            <span class="contest-icon" v-if="item.courseSet.type === 'contest'">比赛</span>
            <span class="training-icon" v-else-if="item.courseSet.type === 'training'">训练</span>
          </p>
          <p>完成度 {{ competitionData[item.parentId].rate }}%</p>
        </div>
        <div class="item-btn">
          <el-button class="btn" size="medium" v-if="$attrs.member&&item.courseSet.type === 'contest'" @click="openHistory(item.parentId)">回顾记录</el-button>
          <el-button type="primary" size="medium " v-if="!$attrs.member" @click="warning">开始学习</el-button>
          <el-button type="primary" size="medium " v-else-if="item.courseSet.type === 'contest'" @click="replay(item.parentId)">{{
            competitionData[item.parentId].rate | btnText
          }}</el-button>
          <el-button type="primary" size="medium " v-else-if="item.courseSet.type === 'training'" @click="training(item.parentId)">{{
            competitionData[item.parentId].rate | btnText
          }}</el-button>
        </div>
      </li>
    </ul>
    <el-dialog title="回顾记录" :visible.sync="dialogTableVisible">
      <HistoryData :competition_id="competition_id" :classroom_id="$route.params.classroomId" />
    </el-dialog>
  </div>
</template>

<script>
import { createReplay } from "@/api/contest.js";
import HistoryData from "@/components/HistoryData";
export default {
  props: ["isLogin"],
  components: {
    HistoryData
  },
  data() {
    return {
      currentPage: 1,
      totalCount: 200,
      pageSize: 20,
      classroom: null,
      competition_id: "",
      classroom_id: "",
      competitionData: null,
      dialogTableVisible: false,
      member: null,
      courses: null,
      list: [
        {
          title: "初级淘宝美工入门界面介绍",
          avatar: require("../../assets/imgs/u326.svg"),
          type: "contest",
          progress: "40",
          status: 1
        },
        {
          title: "简单淘宝海报制作",
          avatar: require("../../assets/imgs/u326.svg"),
          type: "training",
          progress: "60",
          status: 2
        }
      ]
    };
  },
  methods: {
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
    },
    warning() {
      this.$alert("你还不是专题成员，请先加入专题", "提示", {
        confirmButtonText: "确定"
      });
    },
    openHistory(id) {
      this.competition_id = id;
      this.dialogTableVisible = true;
    },
    replay(competition_id) {
      let params = {
        classroom_id: this.classroom_id,
        competition_id: competition_id,
        replay_type: 2
      };
      createReplay(params).then(response => {
        this.$router.push({
          name: "special-introduce",
          params: {
            classroomId: this.classroom_id,
            competitionId: competition_id,
            times: response.data,
            replay_type: 2
          }
        });
      });
    },
    training(id) {
      this.$router.push({
        name: "train-special-index",
        params: { competitionId: id, replayType: 2, classroomId: this.classroom_id }
      });
    },
    toLearn: function () {
      if (!this.isLogin) {
        this.$router.push({
          name: "login",
          params: { type: "login" },
          query: { redirect: this.$route.path }
        });
      }
    }
  },
  created() {
    this.classroom_id = this.$route.params.classroomId;
    this.courses = { ...this.$attrs.courses };
    this.competitionData = { ...this.$attrs.competitionData };
  },
  mounted() {
    this.member = this.$attrs.member;
  },
  filters: {
    btnText: function (value) {
      let status = "";
      switch (true) {
        case value == 0:
          status = "开始学习";
          break;
        case value == 100:
          status = "重新学习";
          break;
        default:
          status = "继续学习";
      }
      return status;
    }
  }
};
</script>

<style scoped>
.content {
  width: 1000px;
  margin: auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.path-item {
  height: 110px;
  width: 100%;
  border: 1px solid #dce1e6;
  display: flex;
  margin-bottom: 20px;
  border-radius: 3px;
}
.path-item .item-avatar {
  padding: 10px;
  width: 90px;
}
.item-avatar img {
  width: 90px;
  height: 90px;
}
.path-item .item-title {
  width: calc(100% - 350px);
}
.item-title p {
  line-height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-title .contest-icon {
  padding: 3px 10px;
  background-color: #f59a23;
  border-radius: 5px;
  color: #ffffff;
  margin-left: 5px;
}
.item-title .training-icon {
  padding: 3px 10px;
  background-color: #409eff;
  border-radius: 5px;
  color: #ffffff;
  margin-left: 5px;
}
.path-item .item-btn {
  text-align: right;
  line-height: 110px;
  width: 220px;
  box-sizing: border-box;
  float: right;
}

.path-item .item-btn button:first-child {
  margin-bottom: 10px;
}
.content-page {
  text-align: center;
  margin: 20px 0;
}
</style>
